import { useGetEventsList as useGetEvents } from '@wbk/contentful/api';

export function useGetEventsList(
  query: Parameters<typeof useGetEvents>[0] = {},
  options?: Parameters<typeof useGetEvents>[1]
) {
  return useGetEvents(
    {
      ...query,
      where: {
        ...(query?.where || {}),
        season: { slug: 'riyadh-season-2025' },
      },
    },
    options
  );
}
